

require('./bootstrapcp');

require('./jsparts/popup');
require('./jsparts/cusalert');
require('./jsparts/cusDialog');


require('./jsparts/sizeWin');
require('./jsparts/deskSubMenu');
require('./jsparts/updateDateTime');
require('./jsparts/ckEditBox');
require('./jsparts/picUplBoxReplace');
require('./jsparts/fancyTable');
//require('./jsparts/addEditDelBtns');
require('./jsparts/formMagic');
require('./jsparts/cp/notifiers');
require('./jsparts/cp/notifications');

$('body').on('click', '.switchListBtn', function(e){
	e.preventDefault();
	
	$(".device_list").toggleClass("hidden");
	$(".batches").toggleClass("hidden");
});

require('./jsparts/pieChart.js');
require('./jsparts/lineChart.js');




var roothtml = "/";
window.mobMenu = false;
window.bgnav = "";

// update raw dates to human readable
var updateTime = setInterval(function(){updateDateTime();}, 30000);
updateDateTime();

window.addEventListener('tableReload', event => {
	sizeWin();
    updateDateTime();
});


$(window).resize(function(){
	sizeWin();
	window.Popup.resize();
});



$(document).ready(function(){
	sizeWin();
	window.Popup.resize();
	deskSubMenu();
	ckEditBox();
	var mobmenubusy = false;
	
	$('body').on('click','#mobmenubtn',function(){
		if(mobmenubusy == false){
			var bgHtml = '<div class="bgNav"></div>';
			mobmenubusy = true;
			
			if(window.mobMenu == false){
				if($(".bgNav").length == 0) {
					window.bgnav = $(bgHtml);
					$("header").after(window.bgnav);
				}
				window.bgnav.fadeIn('fast');
				$('header nav').slideDown('fast', function(){
					window.mobMenu = true;
					$(this).addClass('do');
					mobmenubusy = false;
				});
			}else{
				window.bgnav.fadeOut('fast');
				$('header nav').slideUp('fast', function(){
					window.mobMenu = false;
					$(this).removeClass('do');
					mobmenubusy = false;
				});
			}
		}
	});

	$('body').on('click','.pub_add .frBtn',function(){
		//alert("dfd");

		$(this).parents(".fileInpUI").find(".orgFileField").click();
	});
});
	

	
	

	

window.confirm = function(text, callback, style=null){
	
	// If style is given, apply it
	if(style){
		$("#confirm .modal .modal_hdr").addClass(style);
		$("#confirm .modal .modal_ftr .yesBtn").addClass(style);
	}
	
	// Set the confirmation modal text
	$("#confirm .modal .modal_content").html(text);
	
	// Show the confirmation modal
	$("#confirm").removeClass("hidden").show();
	
	// On click no
	$("#confirm .modal .noBtn").click(function(){
		// Reset the confirmation modal
		confirmModalReset(style);
		
		return false;
	});
	
	// On click yes
	$("body").on("click", "#confirm .modal .yesBtn", function(e){
		e.preventDefault();
		
		if(callback){
			callback();
			callback = null;
		}
		
		// Reset the confirmation modal
		confirmModalReset(style);
		
		return true;
	});
}

function confirmModalReset(style){
	// Hide the confirmation modal
	$("#confirm").hide();
	
	// If style was given, remove it
	if(style){
		$("#confirm .modal .modal_hdr").removeClass(style);
		$("#confirm .modal .modal_ftr .yesBtn").removeClass(style);
	}
	
	// Remove the confirmation modal text
	$("#confirm .modal .modal_content").html("");
}



	
	

	
	
	
	
/**
	control panel related function & actions
*/

	
	
	


window.copyToClipboard = function (element) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
}		
		
		

/**
	control panel page specific related function & actions
*/
	// $("body").on("change", '.edit_hld select[name="board_id"]', function(){
	// 	$('.edit_hld select[name="module_id"]').val(0);
	// });			
	// $("body").on("change", '.edit_hld select[name="module_id"]', function(){
	// 	$('.edit_hld select[name="board_id"]').val(0);
	// });




	// // on edit this item button click
	// $('body').on('click', '.removeBtn', function(e){
	// 	e.preventDefault();
		
	// 	axios.get($(this).attr('href'), {params: {id: $(this).attr('data-id')}})
	// 		.then(function (respons) {
	// 			// refresh project data
	// 			refreshPageData();
	// 		})
	// 		.catch(function (error) {
	// 			if(error.response && (error.response.status === 401 || error.response.status === 419)){
	// 				window.location.href = "/login";
	// 			}
	// 		});
	// });
	
	
	
	
/*    Begin Plugin    */
// ;;(function($){$.winFocus||($.extend({winFocus:function(){var a=!0,b=[];$(document).data("winFocus")||$(document).data("winFocus",$.winFocus.init());for(x in arguments)"object"==typeof arguments[x]?(arguments[x].blur&&$.winFocus.methods.blur.push(arguments[x].blur),arguments[x].focus&&$.winFocus.methods.focus.push(arguments[x].focus),arguments[x].blurFocus&&$.winFocus.methods.blurFocus.push(arguments[x].blurFocus),arguments[x].initRun&&(a=arguments[x].initRun)):"function"==typeof arguments[x]?b.push(arguments[x]):
// "boolean"==typeof arguments[x]&&(a=arguments[x]);b&&(1==b.length?$.winFocus.methods.blurFocus.push(b[0]):($.winFocus.methods.blur.push(b[0]),$.winFocus.methods.focus.push(b[1])));if(a)$.winFocus.methods.onChange()}}),$.winFocus.init=function(){$.winFocus.props.hidden in document?document.addEventListener("visibilitychange",$.winFocus.methods.onChange):($.winFocus.props.hidden="mozHidden")in document?document.addEventListener("mozvisibilitychange",$.winFocus.methods.onChange):($.winFocus.props.hidden=
// "webkitHidden")in document?document.addEventListener("webkitvisibilitychange",$.winFocus.methods.onChange):($.winFocus.props.hidden="msHidden")in document?document.addEventListener("msvisibilitychange",$.winFocus.methods.onChange):($.winFocus.props.hidden="onfocusin")in document?document.onfocusin=document.onfocusout=$.winFocus.methods.onChange:window.onpageshow=window.onpagehide=window.onfocus=window.onblur=$.winFocus.methods.onChange;return $.winFocus},$.winFocus.methods={blurFocus:[],blur:[],focus:[],
// exeCB:function(a){$.winFocus.methods.blurFocus&&$.each($.winFocus.methods.blurFocus,function(b,c){this.apply($.winFocus,[a,!a.hidden])});a.hidden&&$.winFocus.methods.blur&&$.each($.winFocus.methods.blur,function(b,c){this.apply($.winFocus,[a])});!a.hidden&&$.winFocus.methods.focus&&$.each($.winFocus.methods.focus,function(b,c){this.apply($.winFocus,[a])})},onChange:function(a){var b={focus:!1,focusin:!1,pageshow:!1,blur:!0,focusout:!0,pagehide:!0};if(a=a||window.event)a.hidden=a.type in b?b[a.type]:
// document[$.winFocus.props.hidden],$(window).data("visible",!a.hidden),$.winFocus.methods.exeCB(a);else try{$.winFocus.methods.onChange.call(document,new Event("visibilitychange"))}catch(c){}}},$.winFocus.props={hidden:"hidden"})})(jQuery);
// /*    End Plugin      */



// $.winFocus(function(event, isVisible) {
//     if(isVisible){
// 		// refresh project data
// 		refreshPageData();
// 	}
// }, false);






var searchfor = "";
// when popup searchbox is used
$("body").on('keyup change', '.popupCnt .pop_opt_search', function(){
	var thisEl	= $(this);
	searchfor	= thisEl.val();
	
	if(searchfor != ""){
		thisEl.addClass('used');
	}else{
		thisEl.removeClass('used');
	}
	
	$('.popupCnt .pop_opt_filter.sel').removeClass('sel');
	fb_search(searchfor);
});

// when popup filter buttons are used
$("body").on('click', '.popupCnt .pop_opt_filter', function(){
	var thisEl = $(this);
	filter = thisEl.attr('data-cat');
	
	if(thisEl.hasClass('sel')){
		
		thisEl.removeClass('sel');
		if(searchfor){
			$('.popupCnt .pch_item[data-cat*="' + filter +'"].result').fadeIn();
		}else{
			$('.popupCnt .pch_item[data-cat*="' + filter +'"]').fadeIn();
			$('.subTitle[data-cat*="' + filter +'"]').fadeIn();
			$('.listSpacer[data-cat*="' + filter +'"]').fadeIn();
		}
		
	}else{
		
		thisEl.addClass('sel');
		if(searchfor){
			$('.popupCnt .pch_item[data-cat*="' + filter +'"].result').fadeOut();
		}else{
			$('.popupCnt .pch_item[data-cat*="' + filter +'"]').fadeOut();
			$('.subTitle[data-cat*="' + filter +'"]').fadeOut();
			$('.listSpacer[data-cat*="' + filter +'"]').fadeOut();
		}
	}
	
});

function fb_search(searchfor){
	if(searchfor != ""){
		$(".popupCnt .pch_item").each(function(){
			var found = false;
			
			if($('.pch_item_title', this).text().indexOf(searchfor) > -1){
				found = true;
			}else if($('.pch_item_title', this).text().toUpperCase().indexOf(searchfor) > -1){
				found = true;
			}else if($('.pch_item_title', this).text().toLowerCase().indexOf(searchfor) > -1){
				found = true;
			}
			
			if(found){
				$(this).fadeIn().addClass('result');
			}else{
				$(this).fadeOut().removeClass('result');
			}
		});
	}else{
		$(".popupCnt .pch_item").fadeIn().removeClass('result');
	}
}